import React from "react";
import { Calendar } from "lucide-react";
import type { PreStartupDisplayProps } from "./PreStartupDisplay.types";

const PreStartupDisplay: React.FC<PreStartupDisplayProps> = ({
  currentDate,
  startDate,
}) => {
  return (
    <div className="text-center text-white/45 py-8">
      <div className="mb-4">
        <Calendar className="w-12 h-12 mx-auto text-white/40 mb-2" />
        <h4 className="font-medium text-white/65 mb-2">Pre-Startup Period</h4>
        <p className="text-sm">No financial activity yet. Startup begins on:</p>
        <p className="font-medium text-white/75 mt-1">
          {startDate.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>
        <p className="text-xs mt-2 text-white/40">
          (
          {Math.ceil(
            (startDate.getTime() - currentDate.getTime()) /
              (24 * 60 * 60 * 1000),
          )}{" "}
          days to go)
        </p>
      </div>
      <div className="text-xs text-white/40 border-t pt-4">
        <p>
          This is historical context before your startup officially began.
        </p>
        <p className="mt-1">Move the timeline forward to see financial activity.</p>
      </div>
    </div>
  );
};

export default PreStartupDisplay;